import * as React from "react";
function SvgEdit(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em" {...props}><path d="M85.333 282.64v80h80l213.334-213.333-80-80zM441.707 56.08L391.893 6.267c-8.32-8.32-21.867-8.32-30.187 0L320 47.973l80 80 41.707-41.707c8.32-8.319 8.32-21.866 0-30.186z" /><path d="M0 426.64h512v85.333H0z" opacity={0.36} /></svg>;
}
export default SvgEdit;